import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["visibleDesktop", "hiddenDesktop", "visibleMobile", "hiddenMobile", "button", "desktopDivider", "mobileDivider"]

  connect() {
    // Initialize button text
    const button = this.targets.find("button")
    if (button) {
      this.updateButtonText()
    }
  }

  toggle() {
    const isDesktop = window.innerWidth >= 768 // md breakpoint
    const hiddenTarget = isDesktop ? this.hiddenDesktopTarget : this.hiddenMobileTarget
    const isHidden = hiddenTarget.classList.contains("hidden")
    
    const dividerTarget = isDesktop ? this.desktopDividerTarget : this.mobileDividerTarget
    dividerTarget.classList.toggle("hidden")
    
    // Remove hidden class first to trigger transition
    hiddenTarget.classList.remove("hidden")
    
    // Set max height to auto after a small delay to ensure transition
    setTimeout(() => {
      // Only set max height for desktop layout
      if (isDesktop) {
        hiddenTarget.style.maxHeight = isHidden ? hiddenTarget.scrollHeight + "px" : "0"
      } else {
        // For mobile, set opacity
        hiddenTarget.style.opacity = isHidden ? "1" : "0"
      }
      
      // Add hidden class back after transition completes
      setTimeout(() => {
        if (!isHidden) {
          hiddenTarget.classList.add("hidden")
        }
        // Update button text only after transition completes
        this.updateButtonText()
      }, 300) // Match the duration from CSS
    }, 10)
  }

  updateButtonText() {
    const isDesktop = window.innerWidth >= 768 // md breakpoint
    const hiddenTarget = isDesktop ? this.hiddenDesktopTarget : this.hiddenMobileTarget
    const isHidden = hiddenTarget.classList.contains("hidden")
    this.buttonTarget.textContent = isHidden ? "Show More" : "Show Less"
  }
}